/*
 * ReviewsSlider — custom element for the PDP reviews slider.
 *
 * Extends the theme's existing QuoteSlider (which extends SliderComponent) and
 * overrides the button click handler so programmatic navigation smooth-scrolls
 * between slides.
 *
 * Why this override exists:
 *   The base SliderComponent.onButtonClick calls `this.slider.scrollTo({left: X})`
 *   without a `behavior` argument, which means it inherits CSS scroll-behavior.
 *   The list CSS intentionally uses `scroll-behavior: auto` (see
 *   component-reviews-slider.css) because Chromium silently drops programmatic
 *   scrollTo calls when scroll-behavior: smooth is combined with scroll-snap
 *   on an overflow:auto container. Passing `behavior: 'smooth'` directly to the
 *   scrollTo call works around that bug and restores smooth sliding.
 */
(function () {
  function defineReviewsSlider() {
    const QuoteSlider = customElements.get('quote-slider');
    if (!QuoteSlider || customElements.get('reviews-slider')) return;

    class ReviewsSlider extends QuoteSlider {
      onButtonClick(event) {
        event.preventDefault();
        if (!this.sliderItemOffset) return;

        const step = Number(event.currentTarget.dataset.step) || 1;
        const direction = event.currentTarget.name === 'next' ? 1 : -1;
        let target = this.slider.scrollLeft + direction * step * this.sliderItemOffset;
        if (window.theme && theme.config && theme.config.rtl) target = target * -1;

        this.slider.scrollTo({ left: target, behavior: 'smooth' });
      }
    }

    customElements.define('reviews-slider', ReviewsSlider);
  }

  if (customElements.get('quote-slider')) {
    defineReviewsSlider();
  } else {
    // global.js defines quote-slider; wait for it if this script loads first.
    document.addEventListener('DOMContentLoaded', defineReviewsSlider);
    window.addEventListener('load', defineReviewsSlider);
  }
})();
